import { render, staticRenderFns } from "./AutoSuggestSection.vue?vue&type=template&id=21267c8a&"
import script from "./AutoSuggestSection.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports